/**
 * API de Assinaturas.
 *
 * Para checkout, o frontend coleta dados do cartão e envia VIA TLS para a API.
 * A API tokeniza na Cielo imediatamente e descarta o PAN. Em nenhum momento
 * o PAN aparece no banco da Novità. Modo PCI SAQ-A-EP.
 */
import { api } from './client';

export type StatusAssinatura =
  | 'pendente'
  | 'ativa'
  | 'inadimplente'
  | 'suspensa'
  | 'cancelada';

export interface Assinatura {
  id: string;
  plano_id: string;
  status: StatusAssinatura;
  valor_centavos: number;
  cielo_brand: string | null;
  cielo_last4: string | null;
  iniciada_em: string | null;
  proxima_cobranca: string | null;
  ultima_cobranca_ok: string | null;
}

export interface CheckoutAssinaturaPayload {
  plano_sku: string;
  card_number: string;
  card_holder: string;
  card_expiry: string; // MM/YYYY
  card_cvv: string;
  bandeira: 'Visa' | 'Master' | 'Elo' | 'Amex' | 'Hipercard' | 'Discover';
}

export const assinaturasApi = {
  checkout: (payload: CheckoutAssinaturaPayload) =>
    api.post<Assinatura>('/api/assinaturas/checkout', payload),

  minha: () => api.get<Assinatura | null>('/api/assinaturas/minha'),

  cancelar: (id: string, motivo: string) =>
    api.post<Assinatura>(`/api/assinaturas/${id}/cancelar`, { motivo }),
};

/**
 * Detecta a bandeira do cartão pelo BIN (primeiros dígitos).
 * Cobre as bandeiras suportadas pela Cielo no Brasil.
 */
export function detectarBandeira(numero: string): CheckoutAssinaturaPayload['bandeira'] | null {
  const limpo = numero.replace(/\D/g, '');
  if (/^4/.test(limpo)) return 'Visa';
  if (/^5[1-5]/.test(limpo) || /^2[2-7]/.test(limpo)) return 'Master';
  if (/^3[47]/.test(limpo)) return 'Amex';
  if (/^(4011|4312|4389|4514|4573|6362|6363|6504|6505|6516|6550|509)/.test(limpo)) return 'Elo';
  if (/^(38|60)/.test(limpo)) return 'Hipercard';
  if (/^6011/.test(limpo)) return 'Discover';
  return null;
}
